<template>
  <v-dialog
    v-model="showing_faculty_bank_account_modal"
    persistent
    eager
    max-width="600"
  >
    <v-card>
      <v-form
        ref="form"
        v-model="faculty_bank_account_form_status"
        v-on:submit.prevent="add_form_validate"
      >
        <v-card-title class="headline">
          {{ $t("officer_config.config_faculty_bank_account") }} (
          {{
            form_mode === FORM_MODES.ADD
              ? $t("officer_config.addnew")
              : $t("officer_config.edit")
          }}
          )
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="configFacultyBankAccount_facultyId"
            v-bind:label="$t('officer_config.faculty')"
            v-bind:items="registrar_faculties"
            v-bind:item-value="(item) => item.FACULTY_ID"
            v-bind:item-text="(item) => objectTranslator(item, 'FACULTY_NAME')"
            v-bind:rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <v-text-field
            v-model="configFacultyBankAccount_infoTh"
            v-bind:label="$t('officer_config.bank_info_th')"
            v-bind:rules="requiredRules"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="configFacultyBankAccount_infoEn"
            v-bind:label="$t('officer_config.bank_info_en')"
            v-bind:rules="requiredRules"
            outlined
            dense
          ></v-text-field>
          <v-autocomplete
            v-model="configFacultyBankAccount_bankCode"
            v-bind:label="$t('officer_config.bank_logo')"
            v-bind:items="banks"
            v-bind:item-value="(item) => item.BANK_CODE"
            v-bind:item-text="(item) => item.BANK_CODE"
            v-bind:rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <v-text-field
            v-model="configFacultyBankAccount_serviceCharge"
            v-bind:label="$t('officer_config.service_charge')"
            type="number"
            v-bind:rules="requiredRules"
            outlined
            dense
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="form_validate()">
            {{ $t("officer_config.save") }}</v-btn
          >
          <v-btn
            color="error"
            dark
            @click="showing_faculty_bank_account_modal = false"
            >{{ $t("officer_config.cancel") }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import {
  objectTranslator,
  objectTranslatorLowerCase,
} from "@/helper/translator";
import validator from "@/helper/validator";
import ConfigProvider from "@/services/config.provider";
import RefProvider from "@/services/ref.provider";
import FacultyProvider from "@/services/faculty.provider";

const refService = new RefProvider();
const facultyService = new FacultyProvider();
const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

const FORM_MODES = { ADD: 0, EDIT: 1 };

export default {
  name: "ConfigFacultyBankAccount",
  props: {
    toggle_loading: Function,
  },
  data: function() {
    return {
      FORM_MODES,
      form_mode: null,
      faculty_bank_account_form_status: null,
      showing_faculty_bank_account_modal: false,

      registrar_faculties: [],
      banks: [],

      configFacultyBankAccount_id: null,
      configFacultyBankAccount_levelId: null,
      configFacultyBankAccount_facultyId: null,
      configFacultyBankAccount_infoTh: null,
      configFacultyBankAccount_infoEn: null,
      configFacultyBankAccount_bankCode: null,
      configFacultyBankAccount_serviceCharge: null,

      requiredRules: [validator.required],
    };
  },
  components: {},
  computed: {
    levels() {
      return this.$store.state.ref.levels;
    },
    ...mapOfficerConfigFields({
      config_facultyBankAccounts: "config_facultyBankAccounts",
    }),
  },
  methods: {
    objectTranslator,
    objectTranslatorLowerCase,

    async fetch_data() {
      const faculties = await facultyService.getFaculties();
      this.registrar_faculties = faculties;

      const banks = await refService.getBank();
      this.banks = banks;
    },

    //open_add_modal: function(level_id) {
    async open_add_modal(level_id) {
      await this.fetch_data();
      this.form_mode = FORM_MODES.ADD;
      this.$refs.form.reset();
      this.configFacultyBankAccount_levelId = level_id;
      this.showing_faculty_bank_account_modal = true;
    },
    async open_edit_modal(item) {
      await this.fetch_data();
      this.form_mode = FORM_MODES.EDIT;
      this.configFacultyBankAccount_id = item.ID;
      this.configFacultyBankAccount_levelId = item.LEVEL_ID;
      this.configFacultyBankAccount_facultyId = item.REGISTRAR_FACULTY_ID;
      this.configFacultyBankAccount_infoTh = item.BANK_INFO_TH;
      this.configFacultyBankAccount_infoEn = item.BANK_INFO_EN;
      this.configFacultyBankAccount_bankCode = item.BANK_CODE;
      this.configFacultyBankAccount_serviceCharge = item.SERVICE_CHARGE;
      this.showing_faculty_bank_account_modal = true;
    },
    form_validate: function() {
      if (this.form_mode === FORM_MODES.ADD) {
        this.add_form_validate();
      } else if (this.form_mode === FORM_MODES.EDIT) {
        this.edit_form_validate();
      }
    },
    add_form_validate: async function() {
      this.$refs.form.validate();
      if (this.faculty_bank_account_form_status) {
        this.showing_faculty_bank_account_modal = false;
        this.toggle_loading(true);

        let response = await configService
          .saveFacultyBankAccounts({
            level_id: this.configFacultyBankAccount_levelId,
            faculty_id: this.configFacultyBankAccount_facultyId,
            bank_info_th: this.configFacultyBankAccount_infoTh,
            bank_info_en: this.configFacultyBankAccount_infoEn,
            bank_code: this.configFacultyBankAccount_bankCode,
            service_charge: this.configFacultyBankAccount_serviceCharge,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getFacultyBankAccounts");
        if (response && response.status)
          this.$toasted.success(this.$t("toasted.create_successfully"));
        else this.$toasted.error(this.$t("toasted.cannot_create"));

        this.toggle_loading(false);
      }
    },
    edit_form_validate: async function() {
      this.$refs.form.validate();
      if (this.faculty_bank_account_form_status) {
        this.showing_faculty_bank_account_modal = false;
        this.toggle_loading(true);

        let response = await configService
          .editFacultyBankAccounts({
            id: this.configFacultyBankAccount_id,
            level_id: this.configFacultyBankAccount_levelId,
            faculty_id: this.configFacultyBankAccount_facultyId,
            bank_info_th: this.configFacultyBankAccount_infoTh,
            bank_info_en: this.configFacultyBankAccount_infoEn,
            bank_code: this.configFacultyBankAccount_bankCode,
            service_charge: this.configFacultyBankAccount_serviceCharge,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getFacultyBankAccounts");
        if (response && response.status)
          this.$toasted.success(this.$t("toasted.edit_successfully"));
        else this.$toasted.error(this.$t("toasted.cannot_edit"));

        this.toggle_loading(false);
      }
    },
  },
  mounted: function() {},
};
</script>
